import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate, useLocation } from 'react-router-dom';

const LoginAuth0 = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Si ya está autenticado, redirigir al dashboard
    if (isAuthenticated) {
      navigate('/dashboard');
      return;
    }

    // Si no está cargando y no está autenticado, redirigir automáticamente a Auth0
    if (!isLoading && !isAuthenticated) {
      // Capturar el plan de la URL si existe
      const searchParams = new URLSearchParams(location.search);
      const plan = searchParams.get('plan');

      loginWithRedirect({
        authorizationParams: {
          screen_hint: plan ? 'signup' : undefined // Si viene con plan, mostrar signup
        },
        appState: {
          returnTo: '/dashboard',
          plan: plan // Guardar el plan para usarlo después
        }
      });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect, navigate, location]);

  // Mostrar loading mientras redirige
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '1rem'
    }}>
      <div style={{ fontSize: '3rem' }}>🔄</div>
      <p style={{ fontSize: '1.2rem', color: '#7c3aed' }}>Redirigiendo a inicio de sesión...</p>
    </div>
  );
};

export default LoginAuth0;